import React from 'react';

import PopupMobileSticked from '../../../components/Popup/PopupMobileSticked';
import * as localizationKeys from '../../../consts/localization/localizationKeys';
import {getLocalizedStrings} from '../../../services/localization/localizationService';
import modalService from '../../../services/modalService';
import FeedbackPopupContent from './components/FeedbackPopupContent';

const ConsumerFeedbackGatheringPopup = ({modalType}) => {
    const localizedStrings = getLocalizedStrings();

    const onClose = () => {
        modalService.hideModal(modalType);
    };

    const onSubmitButtonClick = (collectedData) => {
        // GETTING COLLECTED DATA FROM THE FEEDBACK POPUP
        console.log(collectedData);
        onClose();
    };

    return (
        <PopupMobileSticked
            className='flex flex-col items-center px-8 md:max-w-[568px] md:pb-8'
            onClose={onClose}
            closeButtonAriaLabel={localizedStrings[localizationKeys.FEEDBACK_MODAL_CLOSE_BUTTON_ARIA_LABEL]}
            isCloseVisible
        >
            <FeedbackPopupContent onSubmitButtonClick={onSubmitButtonClick} />
        </PopupMobileSticked>
    );
};

export default ConsumerFeedbackGatheringPopup;
